var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [!_vm.apiKeyError ? _c('core-dtwin-state-preview-db-tiles', {
    key: _vm.counter,
    staticClass: "public-title-container",
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "updatedStates": _vm.updatedStates
    }
  }) : _c('div', {
    staticClass: "d-flex justify-center align-center",
    staticStyle: {
      "height": "100vh",
      "color": "red"
    }
  }, [_c('h2', [_vm._v("Error: Unauthorized")])]), !_vm.apiKeyError && _vm.footerData.showFooterPublicDashboard ? _c('div', [_c('core-footer', {
    attrs: {
      "footerData": _vm.footerData,
      "publicDashboardVersion": true
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };